import React, { useState, useEffect } from "react";
import { StyledGrid } from "../../elements";
import styled from "styled-components";
import ReactImageZoom from "react-image-zoom";
import { makeStyles, useTheme } from "@material-ui/core/styles";

import { Box, Typography, useMediaQuery } from "@material-ui/core";

const StyledGalleryContainer = styled.div`
  width: 100%;

  .gallery-product-container {
    width: 100%;
    margin: 0 0 0 0;
    .product-thumbnail-container {
      display: flex;
      justify-content: center;
      @media (min-width: 320px) and (max-width: 599px) {
        flex-direction: row;
      }
    }
    .product-thumbnail {
      display: flex;
      flex-direction: column;
      @media (min-width: 0px) and (max-width: 599px) {
        flex-direction: row;
        overflow: scroll;
      }
      img {
        width: 64px;
        margin: 5px 5px;
        cursor: pointer;
        @media (min-width: 768px) and (max-width: 1100px) {
          width: 64px;
        }

        &:hover {
          border-style: solid;
          border-color: lightseagreen;
          border-width: 1px;
        }
      }

      .img-style {
        width: 64px;
        margin: 5px 5px;
        border-style: solid;
        border-color: lightseagreen;
        border-width: 1px;

        @media (min-width: 768px) and (max-width: 1100px) {
          width: 64px;
        }

        &:hover {
          border-style: solid;
          border-color: lightseagreen;
          border-width: 2px;
        }
      }
    }

    .full-image-product img {
      width: 100%;
      .custom-zoom-image {
        z-index: 99;
      }
    }
  }
`;

const styledMUI = makeStyles((theme) => ({
  txtRibbon: {
    textAlign: "center",
    fontSize: 12,
    paddingTop: 3,
    paddingBottom: 3,
  },
  txtOneRibbon: {
    textAlign: "center",
    fontSize: 12,
    paddingTop: 5,
    paddingBottom: 5,
  },
  boxOnlyProductoGanador: {
    position: "absolute",
    top: 15,
    right: 10,
    width: 75,
  },
  boxProductoGanador: {
    position: "absolute",
    top: 9,
    right: 10,
    width: 75,
    marginTop: 0,
    marginRight: 0,
    marginLeft: 0,
  },

  nuevoUp: {
    position: "absolute",
    top: 20,
    width: 75,
    borderColor: "#815993",
    borderTopRightRadius: 15,
    backgroundColor: "#815993",
    color: "#ffffff",
  },
  nuevo: {
    position: "absolute",
    top: 46,
    width: 75,
    borderColor: "#815993",
    borderTopRightRadius: 15,
    borderBottomRightRadius: 15,
    backgroundColor: "#815993",
    color: "#ffffff",
  },
  nuevoDown: {
    position: "absolute",
    top: 45,
    width: 75,
    borderColor: "#815993",
    borderBottomRightRadius: 15,
    backgroundColor: "#815993",
    color: "#ffffff",
  },
  nuevo20: {
    position: "absolute",
    top: 20,
    width: 75,
    borderColor: "#815993",
    borderTopRightRadius: 20,
    borderBottomRightRadius: 20,
    backgroundColor: "#815993",
    color: "#ffffff",
  },
  txtOnlyRibbon: {
    textAlign: "center",
    fontSize: 12,
    paddingTop: 5,
    paddingBottom: 5,
  },
  dpdOferta: {
    position: "absolute",
    top: 40,
    width: 75,
    borderColor: "#BF0000",
    borderTopRightRadius: 20,
    borderBottomRightRadius: 20,
    backgroundColor: "#BF0000",
    color: "#ffffff",
  },
  dpdOfertaUp: {
    position: "absolute",
    top: 20,
    width: 75,
    borderColor: "#BF0000",
    borderTopRightRadius: 15,
    backgroundColor: "#BF0000",
    color: "#ffffff",
  },
  dpdOfertaDown: {
    position: "absolute",
    top: 45,
    width: 75,
    borderColor: "#BF0000",
    borderBottomRightRadius: 15,
    backgroundColor: "#BF0000",
    color: "#ffffff",
  },
  default20: {
    position: "absolute",
    top: 20,
    width: 75,
    borderColor: "#f18200",
    borderTopRightRadius: 20,
    borderBottomRightRadius: 20,
    backgroundColor: "#f18200",
    color: "#ffffff",
  },
  defaultDown: {
    position: "absolute",
    top: 45,
    width: 75,
    borderColor: "#f18200",
    borderBottomRightRadius: 15,
    backgroundColor: "#f18200",
    color: "#ffffff",
  },
  defaultUp: {
    position: "absolute",
    top: 20,
    width: 75,
    borderColor: "#f18200",
    borderTopRightRadius: 15,
    backgroundColor: "#f18200",
    color: "#ffffff",
  },
  default: {
    position: "absolute",
    top: 20,
    width: 75,
    borderColor: "#f18200",
    borderTopRightRadius: 15,
    borderBottomRightRadius: 15,
    backgroundColor: "#f18200",
    color: "#ffffff",
  },
}));

const GalleryProduct = (props) => {
  const theme = useTheme();
  const classes = styledMUI();
  const xsWidth = useMediaQuery(theme.breakpoints.down("xs"));

  let products = [
    {
      thumbnails: props.thumbnails,
    },
  ];
  const [selectedThumbnail, setSelectedThumbnail] = useState<any>(
    products[0].thumbnails[0] ? products[0].thumbnails[0] : "NA"
  );

  //Thumbnails
  const setBigThumbnail = (thumbnail) => {
    setSelectedThumbnail(thumbnail);
  };

  useEffect(() => {
    setBigThumbnail(selectedThumbnail);
  }, [selectedThumbnail]);

  const { productoGanador, atributosValidos } = props;

  return (
    <React.Fragment>
      <StyledGalleryContainer>
        <div className="gallery-product-container">
          <StyledGrid
            container
            direction={xsWidth ? "column-reverse" : "row"}
            spacing={1}>
            <StyledGrid item xs={12} sm={1}>
              <Box
                className="product-thumbnail-container"
                style={{ marginTop: -5 }}>
                <Box
                  className="product-thumbnail"
                  display="flex"
                  justifyContent="center">
                  {products[0].thumbnails.map((thumbnail, index) => {
                    const url =
                      window.urlBaseImg +
                      `/wcsstore/ExtendedSitesCatalogAssetStore/images/catalog/default/${thumbnail}`;

                    return (
                      <img
                        key={index}
                        onClick={() => setBigThumbnail(thumbnail)}
                        src={url}
                        onError={(event) =>
                          (event.currentTarget.style.display = "none")
                        }
                        alt=" description"
                        className={
                          selectedThumbnail === thumbnail ? "img-style" : ""
                        }
                      />
                    );
                  })}
                </Box>
              </Box>
            </StyledGrid>
            <StyledGrid item xs={12} sm={11}>
              <Box
                className="full-image-product"
                height={xsWidth ? 343 : ""}
                style={{ position: "relative" }}>
                <ReactImageZoom
                  {...{
                    width: xsWidth ? 500 : 654,
                    height: xsWidth ? 343 : 647,
                    zoomWidth: 500,
                    zoomStyle: "z-index:99",
                    img:
                      window.urlBaseImg +
                      `/wcsstore/ExtendedSitesCatalogAssetStore/images/catalog/zoom/${selectedThumbnail}`,
                  }}
                />
                {/* RIBBONS */}
                {atributosValidos && atributosValidos.length === 1
                  ? atributosValidos.map((attribute: any) => (
                      <Box
                        className={
                          attribute.identifier === "DPD_Oferta"
                            ? classes.dpdOferta
                            : attribute.identifier === "Nuevo"
                            ? classes.nuevo
                            : classes.default
                        }
                        border={1}>
                        <Typography className={classes.txtOneRibbon}>
                          {attribute.identifier === "Nuevo"
                            ? attribute.identifier
                            : attribute.values[0].value}
                        </Typography>
                      </Box>
                    ))
                  : atributosValidos &&
                    atributosValidos.length > 1 && (
                      <>
                        <Box>
                          <Box
                            className={
                              atributosValidos[0]?.identifier === "DPD_Oferta"
                                ? classes.dpdOfertaUp
                                : atributosValidos[0]?.identifier === "Nuevo"
                                ? classes.nuevoUp
                                : classes.defaultUp
                            }
                            border={1}>
                            <Typography className={classes.txtRibbon}>
                              {atributosValidos[0]?.identifier === "Nuevo"
                                ? atributosValidos[0]?.identifier
                                : atributosValidos[0]?.values[0]?.value}
                            </Typography>
                          </Box>
                          <Box
                            className={
                              atributosValidos[1]?.identifier === "DPD_Oferta"
                                ? classes.dpdOfertaDown
                                : atributosValidos[1]?.identifier === "Nuevo"
                                ? classes.nuevoDown
                                : classes.defaultDown
                            }
                            border={1}>
                            <Typography className={classes.txtRibbon}>
                              {atributosValidos[1]?.identifier === "Nuevo"
                                ? atributosValidos[1]?.identifier
                                : atributosValidos[1]?.values[0]?.value}
                            </Typography>
                          </Box>
                        </Box>
                        {/* } */}
                      </>
                    )}
                {productoGanador && (
                  <Box
                    style={{
                      bottom: 0,
                    }}>
                    <img
                      src={
                        "https://dpjye2wk9gi5z.cloudfront.net/wcsstore/Dpdirecto/images/insignia-dpd-150x150.png"
                      }
                      alt="icono-producto-ganador"
                      className={classes.boxProductoGanador}
                      style={
                        atributosValidos && atributosValidos.length == 1
                          ? {
                              position: "absolute",
                              right: 20,
                              bottom: 160,
                              width: 75,
                              marginTop: 13,
                              marginRight: 0,
                              marginLeft: 0,
                            }
                          : {
                              position: "absolute",
                              right: 20,
                              bottom: 160,
                              width: 75,
                              marginTop: 0,
                              marginLeft: 0,
                            }
                      }></img>
                  </Box>
                )}

                {/* RIBBONS */}
              </Box>
            </StyledGrid>
          </StyledGrid>
        </div>
        <div id="img_zoom_result" className="img-zoom-efect"></div>
      </StyledGalleryContainer>
    </React.Fragment>
  );
};

export default GalleryProduct;
